module.exports = __webpack_public_path__ + "img/illustrasi_submit_success.2db9a230.gif";